import type { FaireThemeEntity } from "../../entity_types/theme";

export const pop_up_outfit_builders: FaireThemeEntity = {
  token: "pop-up-outfit-builders",
  type: "theme",
  name: "Don't Forget Mom & Kids",
  description: "This theme grows revenue because, despite a wellness-heavy reorder pattern, your history also includes kids + women's graphic sweatshirts, plus crossbody bags and hats/beanies--exactly the kind of ins",
  teaser: "Your store already mixes wellness and apparel -- lean into it.",
  detail: "Despite a wellness-heavy reorder pattern, your history includes kids and women's graphic sweatshirts, crossbody bags, and hats, signaling your customers shop you for more than one need. Curating a shoppable outfit moment turns that browsing behavior into a higher-ticket purchase.",
  bgColor: "#D6E0F0",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_uvxxe6zxjz",
    "p_4dbpy35be8",
    "p_mcnd7wg8ef",
    "p_esvm9equu8",
    "p_3prhvv97tc",
    "p_qrxstx7fm8",
    "p_wwarmy8x25",
    "p_2dwde3z5nd",
    "p_zdbsjva99c",
    "p_pj4t588xxu",
    "p_gdavb5z6k8",
    "p_bjvse7muba",
    "p_arxz9a9msy",
    "p_pg8fwp7s6q",
    "p_dja88ypjme",
    "p_hpekb5fb29",
    "p_q5qnpb5qzx",
    "p_3ekeg5d6pr",
    "p_3bumn48kac",
    "p_6w3b55nwff",
    "p_drd6wqqxts",
    "p_jt64pgatae",
    "p_6x786ygzc4",
    "p_ekr4m9ab9u",
    "p_jj925ex72s",
    "p_pv2wyzdtt5",
    "p_ptmudb7esh",
    "p_vu44yvfxdb",
    "p_nr6tupj8tr",
    "p_s8r6mpcfxv",
    "p_kkugbzhx53",
    "p_rx6sthfyk3",
    "p_ztq6ee633c",
    "p_nh9xq3pf5x",
    "p_822hrhadz5",
    "p_u9akrskcdh",
    "p_qkdeevrq5d",
    "p_98sd57tnmh",
    "p_9x92jbg5hq",
    "p_phcdv8wv7g",
    "p_sy7s9rgrdy",
    "p_gst38r3a43",
    "p_6vzg4mftnk",
    "p_bx9yktx6gt",
    "p_z2kggure7n",
    "p_hdfm7k8nxv",
    "p_s82zqgcx6x",
    "p_cy5ja2t7h3",
    "p_2vg87g9hff",
    "p_vs945k3rqd",
    "p_4tq4kfwebp",
    "p_5ec6dw5b2y",
    "p_6jzv4yzgj8",
    "p_x93v8xds46",
    "p_duv6mkbqmz",
    "p_qq65km9w97",
    "p_aa4wk2da8e",
    "p_8cmw479wca",
    "p_vk3yc9xfvd",
    "p_6frcenrwk7",
    "p_vqdhuyqq88",
    "p_45mt9pkb86",
    "p_m47ktwazvd",
    "p_uf2qwg9hza",
    "p_e6k3chh4qx",
    "p_zz6bmwxhng",
    "p_5mgged7qpz",
    "p_rs8jx57yku",
    "p_2sdcb4vgn4",
    "p_fva7rcfv9t",
    "p_5h5ywaxuye",
    "p_jvdvzeuj9e",
    "p_t97gbcf7qk",
    "p_4evbh2u986",
    "p_423xxf5825",
    "p_yrywfwvtcd",
    "p_rz3n2dckvs",
    "p_z3em5g485b",
    "p_dpj5vz3ueg",
    "p_bh242x6cht",
    "p_7ejtxs2z3k",
    "p_8sjk9zk8yp",
    "p_yxsyqpsrn8",
    "p_mmcbhxghnx",
    "p_asf6zq38pw",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
